type ReviewAnswerListenerType = () => void;

const reviewAnswers: Record<number, string> = {};
const listenersByReviewId = new Map<number, Set<ReviewAnswerListenerType>>();

function getReviewAnswerListeners(reviewId: number): Set<ReviewAnswerListenerType> {
    let listeners = listenersByReviewId.get(reviewId);

    if (!listeners) {
        listeners = new Set();
        listenersByReviewId.set(reviewId, listeners);
    }

    return listeners;
}

function notifyReviewAnswerListeners(reviewId: number): void {
    getReviewAnswerListeners(reviewId).forEach((listener) => {
        listener();
    });
}

export function getReviewAnswerSnapshot(reviewId: number): string {
    return reviewAnswers[reviewId] || '';
}

export function setReviewAnswerSnapshot(reviewId: number, answer: string): void {
    reviewAnswers[reviewId] = answer;
    notifyReviewAnswerListeners(reviewId);
}

export function appendReviewAnswerChunkSnapshot(reviewId: number, chunk: string): void {
    reviewAnswers[reviewId] = (reviewAnswers[reviewId] || '') + chunk;
    notifyReviewAnswerListeners(reviewId);
}

export function subscribeToReviewAnswer(reviewId: number, listener: ReviewAnswerListenerType): () => void {
    const listeners = getReviewAnswerListeners(reviewId);

    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
}
